import React, { Component } from 'react';
import Header from './header.js';
import sportsbook from './../sportsbook/sportsbook.js';
import pixelTracking from './../pixel-tracking/pixel-tracking.js';
import { fetchJson } from './../core/ajax-json.js';
import { sessionKey } from './../store/cookies.js';
import currencyFormatter from './../libs/currency-formatter.js';
import { getLocale } from './../libs/locale.js';
import { emitter } from './../utils/custom-events.js';

const headerTitle = document.getElementById('casino-header-title');
const titleText = document.getElementById('container').dataset.title;
function setTitle() {
	headerTitle.innerHTML = titleText || '';
}

class Sportsbook extends Component {
	componentWillMount() {
		if (sessionKey()) {
			fetchJson('/player/balance')
				.then((response) => {
					fetchJson('/player/currency')
						.then((response2) => {
							const formattedBalance = currencyFormatter.format(response.result.amount, response2.result, getLocale());
							headerTitle.innerHTML = formattedBalance;
						});
				});
		} else {
			setTitle();
		}

		emitter.on('logout', setTitle);

		pixelTracking.push('sports');
		sportsbook.init();
	}

	componentWillUnmount() {
		emitter.off('logout', setTitle);
	}

	render() {
		return (
			<div id="sportsbook-component">
				<Header />
			</div>
		);
	}
}

export default Sportsbook;



// WEBPACK FOOTER //
// ./mobile-core/src/components/sportsbook.js